define([
    "dojo/_base/declare",
    "csi/heading/String"
], function(declare,StringRen) {

    return declare(StringRen, {

        /**
         * @override
         * Enable editing
         */
        reserveContext: function(ctx, h) {
            ctx.pushParams();
            ctx.setReadOnly(false);
            this.inherited(arguments);
        },

        /**
         * @override
         * Disable editing
         */
        releaseContext: function(ctx, h) {
            ctx.pop();
            this.inherited(arguments);
        }
    });
});